import CurrentCaseRequired from "../components/ui/current-case-required.js";
import AccountManagementForm from "../components/ui/form-account-management.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";




export default function AccountManagementPage(props) {
    return (
      <CaseDatabaseCheck>
        <CurrentCaseRequired>
          <AccountManagementForm  />
        </CurrentCaseRequired>
      </CaseDatabaseCheck>
    );
}